export const STRINGS = {
  topBar: {
    menu: {
      home: { en: "Home", sw: "Mwanzo" },
      about: { en: "About Us", sw: "Kuhusu Sisi" },
      services: { en: "Services", sw: "Huduma Zetu" },
      membership: { en: "Membership", sw: "Uanachama" },
      contact: { en: "Contact Us", sw: "Wasiliana Nasi" },
    },
  },

  homeBanner: {
    buttons: {
      learnMore: {
        en: "Our Services",
        sw: "Huduma Zetu",
      },
      support: {
        en: "Support Us",
        sw: "Tuunge Mkono",
      },
    },
    elder: {
      tag: { en: "The Elderly", sw: "Wazee" },
      title: {
        en: "Honoring & Caring for Our Elders",
        sw: "Kutunza na Kuthamini Wazee Wetu",
      },
      subtitle: {
        en: "Providing social protection, basic healthcare, and ensuring a dignified aging experience free from neglect.",
        sw: "Kutoa ulinzi wa kijamii, huduma za msingi za afya, na kuhakikisha uzee wenye heshima bila kutelekezwa.",
      },
    },
    disabled: {
      tag: { en: "The Disabled", sw: "Walemavu" },
      title: {
        en: "Championing Equal Opportunities for All",
        sw: "Kupigania Fursa Sawa kwa Wote",
      },
      subtitle: {
        en: "Advocating for inclusion, fighting stigma, and providing supportive tools to empower people with disabilities.",
        sw: "Kuhimiza ujumuishi, kupiga vita unyanyapaa, na kutoa vifaa saidizi ili kuwawezesha watu wenye ulemavu.",
      },
    },
    youth: {
      tag: { en: "The Youth", sw: "Vijana" },
      title: {
        en: "Bridging Knowledge & Building Futures",
        sw: "Kukuza Maadili na Kujenga Kesho",
      },
      subtitle: {
        en: "Transferring vital traditional wisdom from elders to youth while preparing them for economic independence.",
        sw: "Kurithisha maarifa na maadili mema kutoka kwa wazee kwenda kwa vijana sambamba na kuwaandaa kujitegemea kiuchumi.",
      },
    },
    orphans: {
      tag: { en: "Orphans & Children", sw: "Yatima" },
      title: {
        en: "Nurturing the Next Generation",
        sw: "Kulea Kizazi cha Baadaye",
      },
      subtitle: {
        en: "Securing access to quality education, safe clothing, shelter, and psychological relief for orphaned children.",
        sw: "Kuhakikisha upatikanaji wa elimu bora, mavazi, malazi salama, na msaada wa kisaikolojia kwa watoto yatima.",
      },
    },
    poor: {
      tag: { en: "The Underprivileged", sw: "Maskini" },
      title: {
        en: "Alleviating Extreme Poverty",
        sw: "Kupunguza Umaskini Uliokithiri",
      },
      subtitle: {
        en: "Empowering disadvantaged families with sustainable resources to meet their fundamental human needs.",
        sw: "Kuziwezesha familia zilizo katika mazingira magumu kupata mahitaji ya msingi na rasilimali endelevu.",
      },
    },
    homeless: {
      tag: { en: "The Homeless", sw: "Wasio na Makazi" },
      title: {
        en: "Restoring Safe Shelter and Comfort",
        sw: "Kurejesha Hifadhi na Makazi Salama",
      },
      subtitle: {
        en: "Reintegrating displaced persons and providing essential physical aid to bring stability back to their lives.",
        sw: "Kurejesha watu waliokosa makazi na kuwapatia misaada ya kibinadamu ili kuleta utulivu katika maisha yao.",
      },
    },
    addicts: {
      tag: {
        en: "Substance Abuse Recovery",
        sw: "Waathirika wa Dawa za Kulevya",
      },
      title: {
        en: "Rehabilitation and Renewed Hope",
        sw: "Urekebishaji na Matumaini Mapya",
      },
      subtitle: {
        en: "Delivering professional psychological counseling and rebuilding lives to transform recovery into workforce power.",
        sw: "Utoaji wa ushauri nasaha wa kisaikolojia na kujenga upya uwezo wao ili kurejea kwenye jamii kama nguvu kazi.",
      },
    },
    prisoners: {
      tag: { en: "Inmates & Parolees", sw: "Wafungwa na Waliotoka Gerezani" },
      title: {
        en: "Preparing for a Successful Reintegration",
        sw: "Maandalizi ya Kurejea Salama Jamii",
      },
      subtitle: {
        en: "Equipping individuals with life skills and mental preparation to restart unified lives beyond prison boundaries.",
        sw: "Kuwapatia stadi za maisha na maandalizi ya kisaikolojia ili waweze kuishi vizuri na kukubalika tena katika jamii.",
      },
    },
  },

  homeAbout: {
    topTag: {
      en: "Who We Are",
      sw: "Sisi Ni Nani",
    },
    experienceBadge: {
      en: "Established",
      sw: "Ilianzishwa",
    },
    heading: {
      en: "Restoring Dignity & Hope Across Tanzania",
      sw: "Kurejesha Utu na Matumaini Kote Tanzania",
    },
    description: {
      en: "KUKAJA is a dedicated Non-Governmental Organization (NGO) founded to empower and support individuals living under vulnerable conditions. We actively implement sustainable development operations through corporate social, economic, and psychological infrastructure to bring holistic community transformation.",
      sw: "KUKAJA ni Shirika Lisilo la Kiserikali (NGO) lililoanzishwa kwa ajili ya kuwasaidia na kuwawezesha watu walio katika mazingira magumu. Shirika linatekeleza shughuli za maendeleo endelevu kupitia utoaji wa huduma za kijamii, kiuchumi na kisaikolojia ili kuleta ustawi wa kweli kwenye jamii.",
    },
    buttonText: {
      en: "Learn More About Us",
      sw: "Fahamu Zaidi Kuhusu Sisi",
    },
    stats: {
      regions: {
        number: "26+",
        label: { en: "Regions Reached", sw: "Mikoa Iliyofikiwa" },
      },
      groups: {
        number: "8",
        label: { en: "Vulnerable Groups", sw: "Makundi Yanayolengwa" },
      },
      projects: {
        number: "15+",
        label: { en: "Active Projects", sw: "Miradi Inayoendelea" },
      },
      volunteers: {
        number: "120+",
        label: { en: "Active Volunteers", sw: "Wajitoleaji Wema" },
      },
    },
  },

  homeServices: {
    topTag: {
      en: "What We Do",
      sw: "Tunayoyafanya",
    },
    heading: {
      en: "Our Core Core Pillars of Action",
      sw: "Misingi yetu Mikuu ya Utekelezaji",
    },
    buttonText: {
      en: "Explore Detailed Framework & Services",
      sw: "Fahamu kwa Undani Huduma Zote Nane",
    },
    items: [
      {
        title: { en: "Social Welfare", sw: "Ustawi wa Jamii" },
        highlight: {
          en: "Supporting vulnerable groups in precarious conditions.",
          sw: "Kusaidia makundi yaliyo katika mazingira magumu.",
        },
      },
      {
        title: { en: "Basic Needs & Care", sw: "Huduma za Msingi" },
        highlight: {
          en: "Access to health, quality education, shelter, and nutrition.",
          sw: "Uwezeshaji wa afya, elimu, chakula, mavazi na malazi.",
        },
      },
      {
        title: { en: "Psychological Support", sw: "Ushauri Nasaha" },
        highlight: {
          en: "Professional guidance and trauma therapy systems.",
          sw: "Ushauri nasaha na msaada mkubwa wa kisaikolojia.",
        },
      },
      {
        title: { en: "Life Skills Training", sw: "Stadi za Maisha" },
        highlight: {
          en: "Empowering communities toward absolute self-reliance.",
          sw: "Mafunzo ya stadi za maisha na kujitegemea.",
        },
      },
      {
        title: { en: "Moral & Heritage", sw: "Elimu ya Maadili" },
        highlight: {
          en: "Bridging generational knowledge from elders to youth.",
          sw: "Urithishaji wa maadili na maarifa kutoka kwa wazee.",
        },
      },
      {
        title: { en: "Anti-Discrimination", sw: "Uhamasishaji wa Jamii" },
        highlight: {
          en: "Actively fighting stigma and social segregation.",
          sw: "Kupinga kwa nguvu zote unyanyapaa na ubaguzi.",
        },
      },
      {
        title: { en: "Addiction Recovery", sw: "Huduma za Urekebishaji" },
        highlight: {
          en: "Rehabilitating victims of substance and drug abuse.",
          sw: "Urejeshaji wa waathirika wa dawa za kulevya.",
        },
      },
      {
        title: { en: "Reintegration Support", sw: "Kurejesha Wafungwa" },
        highlight: {
          en: "Preparing inmates for smooth community reintegration.",
          sw: "Maandalizi ya wafungwa kuishi vizuri katika jamii.",
        },
      },
    ],
  },

  homeWhoWeServe: {
    topTag: {
      en: "Impact Target Groups",
      sw: "Walengwa wa Mabadiliko",
    },
    heading: {
      en: "Restoring Hope to those who need it most",
      sw: "Kurejesha Matumaini kwa Wanaohitaji Zaidi",
    },
    subHeading: {
      en: "We focus our operational framework around four core demographics, optimizing resources to secure tangible community progress.",
      sw: "Tunaelekeza nguvu zetu katika makundi makuu manne ya kijamii, tukitumia rasilimali vizuri ili kuleta maendeleo yanayoonekana.",
    },
    cardActionText: {
      en: "View full program",
      sw: "Angalia mpango mzima",
    },
    groups: [
      {
        title: {
          en: "Elders, Widows & Widowers",
          sw: "Wazee, Wajane na Wagane",
        },
        metric: { en: "Care Infrastructure", sw: "Miundombinu ya Ustawi" },
        description: {
          en: "Providing physical care, dignified medical access, clothing, and safe shelter options while eradicating societal neglect.",
          sw: "Kutoa huduma za kimwili, afya, mavazi, na makazi salama huku tukiondoa upweke na kutelekezwa.",
        },
      },
      {
        title: { en: "Addiction & Inmate Reform", sw: "Waathirika & Wafungwa" },
        metric: { en: "Rehabilitation Systems", sw: "Mifumo ya Urekebishaji" },
        description: {
          en: "Comprehensive medical and structural rehabilitation for drug victims, alongside community reintegration preparation for former inmates.",
          sw: "Huduma za urekebishaji kwa waathirika wa dawa za kulevya na maandalizi ya wafungwa kurejea vyema jamii.",
        },
      },
      {
        title: { en: "Youth Empowerment", sw: "Vijana na Stadi za Maisha" },
        metric: { en: "Knowledge Transfer", sw: "Urithishaji Maarifa" },
        description: {
          en: "Bridging structural ethics and skills from village elders to prepare youth for complete economic self-reliance.",
          sw: "Kuunganisha maadili na stadi za maisha kutoka kwa wazee kwenda kwa vijana ili kuwaandaa kujitegemea kiuchumi.",
        },
      },
      {
        title: {
          en: "Vulnerable & Marginalized",
          sw: "Yatima, Walemavu & Maskini",
        },
        metric: { en: "Holistic Welfare Support", sw: "Msaada Kamili wa Utu" },
        description: {
          en: "Securing daily nutritional requirements, educational scholarship pathways, and fighting active discrimination or stigma.",
          sw: "Kuhakikisha upatikanaji wa chakula, fursa za elimu, na kupiga vita unyanyapaa na ubaguzi kwenye jamii.",
        },
      },
    ],
  },

  homeMembership: {
    topTag: {
      en: "Become Part of KUKAJA",
      sw: "Kuwa Sehemu ya KUKAJA",
    },
    heading: {
      en: "Shape a Dignified Tomorrow by Joining Our Network",
      sw: "Tengeneza Kesho Yenye Utu kwa Kujiunga Nasi",
    },
    description: {
      en: "Real community transformation requires collective institutional effort. Whether you wish to contribute professional skills, support operations, or advocate for vulnerable groups, your membership strengthens our capacity across Tanzania.",
      sw: "Mabadiliko ya kweli ya kijamii yanahitaji nguvu ya pamoja. Iwe unataka kuchangia ujuzi wako, kusaidia utekelezaji wa miradi, au kutetea makundi yaliyo katika mazingira magumu, uanachama wako unaongeza nguvu yetu kote nchini.",
    },
    buttonText: {
      en: "Review Membership Portals",
      sw: "Angalia Taratibu za Uanachama",
    },
  },

  homeCTA: {
    heading: {
      en: "Have questions or want to partner with us?",
      sw: "Je, una maswali au ungependa kushirikiana nasi?",
    },
    description: {
      en: "Reach out to our main headquarters or locate our regional desks today.",
      sw: "Wasiliana na makao makuu yetu au fika katika ofisi zetu za mikoa leo.",
    },
    buttonText: {
      en: "Get In Touch",
      sw: "Wasiliana Nasi",
    },
  },

  footer: {
    tagline: {
      en: "Restoring human dignity and creating measurable social frameworks across mainland Tanzania.",
      sw: "Kurejesha utu wa mwanadamu na kutengeneza mifumo thabiti ya kijamii kote Tanzania Bara.",
    },
    linksTitle: {
      en: "Quick Portal",
      sw: "Viungo vya Haraka",
    },
    contactTitle: {
      en: "Headquarters",
      sw: "Makao Makuu",
    },
    nav: {
      home: { en: "Home Overview", sw: "Mwanzo" },
      about: { en: "Our Identity", sw: "Kuhusu Sisi" },
      services: { en: "Core Services", sw: "Huduma Zetu" },
      membership: { en: "Join Network", sw: "Uanachama" },
      contact: { en: "Reach Us", sw: "Wasiliana Nasi" },
    },
  },

  aboutUsPage: {
    hero: {
      kicker: { en: "GET TO KNOW US", sw: "FAHAMU KUHUSU SISI" },
      title: {
        en: "KUKABILI UATHIRIKA KATIKA JAMII (KUKAJA)",
        sw: "KUKABILI UATHIRIKA KATIKA JAMII (KUKAJA)",
      },
    },
    vision: {
      title: { en: "Our Vision", sw: "Maono Yetu" },
      desc: {
        en: "To have a society that cares for, protects, and values the dignity of every person in the community.",
        sw: "Kuwa na jamii inayotunza, kulinda na kuthamini utu wa kila mtu katika jamii.",
      },
    },
    mission: {
      title: { en: "Our Mission", sw: "Dhamira Yetu" },
      desc: {
        en: "To empower people in the community, especially the elderly, disabled, orphans, widows, widowers, those recently released from prison, substance abuse victims, and youth, to live productive lives for the development of the community and the nation as a whole.",
        sw: "Kuwezesha watu katika jamii yaani wazee, walemavu, yatima, wajane, wagane, walioachiwa huru hivi punde kutoka gerezani, waathirika wa madawa ya kulevya na vijana kuishi maisha yenye tija kwa maendeleo ya jamii na taifa kwa ujumla.",
      },
    },
    history: {
      title: {
        en: "Our Preamble & Background",
        sw: "Utangulizi na Historia Yetu",
      },
      desc: {
        en: "KUKAJA is a Non-Governmental Organization (NGO) established in 2025 with the mission to support and empower vulnerable populations, including the elderly, persons with disabilities, orphans, widows, widowers, the underprivileged, individuals recovering from substance abuse, inmates, ex-convicts, and youth. The organization drives sustainable development by delivering social, economic, and psychological support, alongside capacity building and community advocacy in partnership with diverse stakeholders.",
        sw: "KUKAJA ni Shirika Lisilo la Kiserikali (NGO) lililoanzishwa mwaka (2025) kwa lengo la kuwasaidia na kuwawezesha watu walio katika mazingira magumu kama vile wazee, walemavu, yatima, wajane, wagane, maskini, waathirika wa dawa za kulevya, wafungwa na waliotoka gerezani, pamoja na vijana. Shirika linatekeleza shughuli za maendeleo kupitia utoaji wa huduma za kijamii, kiuchumi na kisaikolojia, mafunzo na uhamasishaji wa jamii kwa kushirikiana na wadau mbalimbali.",
      },
    },
    team: {
      title: { en: "OUR TEAM", sw: "TIMU YETU" },
      chairperson: {
        role: { en: "Chairperson", sw: "Mwenyekiti" },
        name: "SALA JACKSON SAMWEL",
        desc: {
          en: "Presides over General Meetings, acts as the main spokesperson, serves as a bank signatory, and oversees the daily activities of the Organization.",
          sw: "Anaongoza Mikutano Mikuu, msemaji mkuu wa shirika, mtia saini wa akaunti ya benki, na msimamizi mkuu wa shughuli za kila siku za taasisi.",
        },
      },
      secretary: {
        role: { en: "General Secretary", sw: "Katibu Mkuu" },
        name: "LETICIA JOSEPH SIAME",
        desc: {
          en: "Convenes meetings in consultation with the Chairperson, manages documents, coordinates office duties, and maintains the asset registry.",
          sw: "Anaratibu na kuitisha mikutano, anaandaa ratiba za ofisi, anatunza nyaraka zote rasmi na kumbukumbu za mali za shirika.",
        },
      },
      treasurer: {
        role: { en: "Treasurer", sw: "Mweka Hazina" },
        name: "LAWRENCE JOSEPH SIAME",
        desc: {
          en: "Receives and secures all funds, prepares annual budgets, maintains comprehensive financial books, and processes banking transactions.",
          sw: "Anapokea na kutunza fedha zote za shirika, anaandaa bajeti ya mwaka, na kutunza kumbukumbu zote za hesabu na ripoti za kifedha.",
        },
      },
    },
    values: {
      title: { en: "Our Core Values", sw: "Maadili Yetu ya Msingi" },
      items: [
        {
          title: { en: "Human Dignity", sw: "Utu" },
          desc: {
            en: "Valuing every single person without any form of discrimination.",
            sw: "Kumthamini kila mtu bila ubaguzi wa aina yoyote.",
          },
        },
        {
          title: { en: "Compassion", sw: "Huruma" },
          desc: {
            en: "Serving those in vulnerable situations with genuine love and care.",
            sw: "Kuwahudumia wenye uhitaji kwa upendo na kujali kwa dhati.",
          },
        },
        {
          title: { en: "Equality & Inclusion", sw: "Usawa na Ujumuishi" },
          desc: {
            en: "Providing equal opportunities and fair platforms for everyone.",
            sw: "Kutoa fursa sawa na majukwaa jumuishi kwa kila mwanajamii.",
          },
        },
        {
          title: { en: "Accountability", sw: "Uwajibikaji" },
          desc: {
            en: "Executing all organizational tasks with honesty and absolute transparency.",
            sw: "Kutekeleza majukumu ya shirika kwa uaminifu na uwazi mkubwa.",
          },
        },
        {
          title: { en: "Empowerment", sw: "Uwezeshaji" },
          desc: {
            en: "Building capacities to enable individuals to become fully self-reliant.",
            sw: "Kujenga uwezo wa watu ili waweze kujitegemea kikamilifu.",
          },
        },
        {
          title: { en: "Cooperation", sw: "Ushirikiano" },
          desc: {
            en: "Working collectively with various stakeholders for societal growth.",
            sw: "Kufanya kazi kwa pamoja na wadau mbalimbali kwa maendeleo ya jamii.",
          },
        },
        {
          title: { en: "Respect", sw: "Heshima" },
          desc: {
            en: "Respecting the rights, voices, and identity of every community member.",
            sw: "Kuheshimu haki na utu wa kila mwanajamii bila masharti.",
          },
        },
      ],
    },
  },

  servicesPage: {
    hero: {
      kicker: { en: "WHAT WE DO", sw: "HUDUMA ZETU" },
      title: { 
        en: "Comprehensive Support & Sustainable Community Empowerment Services", 
        sw: "Huduma Kamili za Msaada na Uwezeshaji Endelevu wa Jamii" 
      }
    },
    items: [
      {
        title: { en: "1. Social Welfare Services", sw: "1. Huduma za Ustawi wa Jamii" },
        desc: {
          en: "Providing professional social protection and structured safety nets for highly marginalized and vulnerable groups, ensuring that the neglected members of our community find immediate refuge, support systems, and a pathway toward social justice and human dignity.",
          sw: "Kutoa ulinzi wa kijamii na mifumo madhubuti ya msaada kwa makundi yaliyo katika mazingira magumu na yaliyotengwa, kuhakikisha wanapata hifadhi salama na njia thabiti kuelekea utu wao."
        }
      },
      {
        title: { en: "2. Basic Needs Empowerment", sw: "2. Uwezeshaji wa Mahitaji ya Msingi" },
        desc: {
          en: "Facilitating structured access to vital human requirements including healthcare, quality education, nutritional support, safe clothing, and dignified shelter, establishing a firm baseline for impoverished families and individuals to thrive.",
          sw: "Kuwezesha upatikanaji wa mahitaji muhimu ya kibinadamu ikiwemo huduma za afya, elimu bora, chakula, mavazi, na malazi salama, ili kuweka msingi imara kwa familia duni kimaisha."
        }
      },
      {
        title: { en: "3. Psychological Counseling & Therapy", sw: "3. Ushauri Nasaha na Msaada wa Kisaikolojia" },
        desc: {
          en: "Delivering expert therapeutic intervention, emotional relief, and mental health counseling to heal individuals suffering from severe life trauma, isolation, or identity crises within the community.",
          sw: "Utoaji wa ushauri nasaha wa kisaikolojia, tiba ya kihisia, na msaada wa afya ya akili ili kuwaponya watu wanaoteseka kutokana na kiwewe kikubwa cha maisha au kutengwa katika jamii."
        }
      },
      {
        title: { en: "4. Life Skills & Self-Reliance Training", sw: "4. Mafunzo ya Stadi za Maisha na Kujitegemea" },
        desc: {
          en: "Equipping youth and vulnerable group members with sustainable vocational skills, entrepreneurial mindsets, and financial literacy to eliminate dependency and construct permanent economic pathways.",
          sw: "Kuwapatia vijana na wanajumuia walio katika mazingira magumu stadi za kazi, mbinu za ujasiriamali, na elimu ya fedha ili kuondoa utegemezi na kujenga uchumi endelevu."
        }
      },
      {
        title: { en: "5. Intergenerational Wisdom Transfer", sw: "5. Urithishaji wa Maarifa na Maadili Mema" },
        desc: {
          en: "Bridging the societal gap by passing down vital cultural values, moral philosophies, and traditional knowledge from elders to the youth while preparing the new generation for a responsible, structured aging experience.",
          sw: "Kuziba pengo la vizazi kwa kurithisha maadili mema, misingi ya kitamaduni, na maarifa ya asili kutoka kwa wazee kwenda kwa vijana sambamba na kutoa elimu ya kujiandaa na uzee."
        }
      },
      {
        title: { en: "6. Anti-Stigma & Advocacy Campaigns", sw: "6. Uhamasishaji wa Kupinga Unyanyapaa" },
        desc: {
          en: "Driving aggressive awareness campaigns to eliminate stigma, discrimination, and societal exclusion against substance abuse survivors, former inmates, and disabled individuals, establishing a unified society.",
          sw: "Kuendesha kampeni kabambe za kuhamasisha jamii kuondoa unyanyapaa, ubaguzi, na utengwaji dhidi ya walioathirika na dawa za kulevya, walioachiwa kutoka gerezani, na wenye ulemavu."
        }
      },
      {
        title: { en: "7. Substance Abuse Rehabilitation", sw: "7. Urekebishaji wa Waathirika wa Dawa za Kulevya" },
        desc: {
          en: "Operating tailored physical detoxification support and extensive behavioral correction structures to successfully transform addiction victims into dynamic national workforce contributors.",
          sw: "Kuendesha mifumo maalum ya marekebisho ya tabia na usaidizi wa kiafya ili kuwawezesha waathirika wa dawa za kulevya kupona kabisa na kurejea kwenye jamii kama nguvu kazi ya taifa."
        }
      },
      {
        title: { en: "8. Inmate Reintegration & Parole Prep", sw: "8. Maandalizi ya Wafungwa Kurejea Jamii" },
        desc: {
          en: "Providing life adaptation education and mental preparation within prison boundaries, alongside physical tool deployment for parolees to ensure an honest, unified, and peaceful reintegration into civil society.",
          sw: "Kutoa elimu ya namna ya kuyakabili maisha mapya, kujitegemea na kujithamini gerezani na baada ya kifungo, ili kuhakikisha wafungwa na waliotoka gerezani wanarejea vizuri katika jamii."
        }
      }
    ]
  },

  membershipPage: {
    hero: {
      kicker: { en: "JOIN OUR MISSION", sw: "JIUNGE NASI" },
      title: { 
        en: "Become a Part of KUKAJA & Transform Vulnerable Lives", 
        sw: "Kuwa Mwanachama wa KUKAJA & Badilisha Maisha ya Wasiojiweza" 
      }
    },
    eligibility: {
      title: { en: "Membership Eligibility", sw: "Sifa za Kujiunga na Uanachama" },
      subtitle: { en: "Article 10 of the KUKAJA Constitution", sw: "Ibara ya 10 ya Katiba ya KUKAJA" },
      desc: {
        en: "Membership to the Organization is completely voluntary and open to any individual who has attained the age of 18 years and above, is of sound mind, and is ready to join hands in supporting and promoting the vision, mission, and development objectives of the Organization.",
        sw: "Uanachama katika shirika hili ni wa hiari na uko wazi kwa mtu yeyote aliyetimiza umri wa miaka 18 na zaidi, mwenye akili timamu, na ambaye yuko tayari kuungana nasi katika kuunga mkono na kukuza maono, dhamira, na malengo ya maendeleo ya taasisi."
      }
    },
    types: {
      title: { en: "Types of Membership", sw: "Aina za Wanachama" },
      founderTitle: { en: "1. Founder Members", sw: "1. Wanachama Waasisi" },
      founderDesc: {
        en: "These are the visionary members who took the initial steps and made the core initiatives to formally establish this Organization.",
        sw: "Hawa ni wanachama waliochukua hatua za kwanza na kufanya juhudi za msingi za kuanzisha rasmi shirika hili."
      },
      ordinaryTitle: { en: "2. Ordinary Members", sw: "2. Wanachama wa Kawaida" },
      ordinaryDesc: {
        en: "These are dedicated members who formally join the Organization to support its mission after its official establishment.",
        sw: "Hawa ni wanachama wanaojiunga rasmi na shirika baada ya kuanzishwa kwake ili kuunga mkono malengo yaliyopo."
      }
    },
    rights: {
      title: { en: "Rights & Obligations", sw: "Haki na Wajibu wa Mwanachama" },
      items: [
        { en: "To elect/vote and be elected/voted into leadership (except honorary members).", sw: "Kuchagua/kupiga kura na kuchaguliwa/kupigiwa kura katika uongozi wa shirika." },
        { en: "Right to be heard and express opinions layout frameworks.", sw: "Haki ya kusikilizwa na kutoa maoni yako." },
        { en: "To attend all General Meetings and official gatherings.", sw: "Kuhudhuria Mikutano Mikuu na mikusanyiko rasmi." },
        { en: "Participate in all scheduled Organization development activities.", sw: "Kushiriki katika shughuli zote zilizopangwa za maendeleo ya shirika." },
        { en: "Receive clear communication regarding the Organization's progress.", sw: "Kupokea taarifa sahihi kuhusu maendeleo ya shirika." },
        { en: "To pay fees that are prescribed and approved by the General Meeting.", sw: "Kulipa ada zilizowekwa na kupitishwa na Mkutano Mkuu." },
        { en: "To strictly keep secret all internal matters and official decisions.", sw: "Kutunza siri za mambo yote ya ndani na maamuzi ya taasisi." }
      ]
    },
    cessation: {
      title: { en: "Cessation of Membership", sw: "Kukoma kwa Uanachama" },
      subtitle: { en: "Membership shall cease if any of the following events occur:", sw: "Uanachama utakoma ikiwa jambo lolote kati ya yafuatayo litatokea:" },
      reasons: [
        { title: { en: "Resignation", sw: "Kujiuzulu" }, desc: { en: "Voluntary withdrawal initiated by the member.", sw: "Kujiondoa kwa hiari kulikoanzishwa na mwanachama." } },
        { title: { en: "Expulsion", sw: "Kufukuzwa" }, desc: { en: "Due to misbehavior or failure to adhere to resolutions.", sw: "Kutokana na tabia mbaya au kutofuata maazimio ya taasisi." } },
        { title: { en: "Absence", sw: "Utoro" }, desc: { en: "Missing 3 consecutive General Meetings without notice.", sw: "Kukosa Mikutano Mikuu mitatu mfululizo bila taarifa." } },
        { title: { en: "Incapability", sw: "Kushindwa Majukumu" }, desc: { en: "Due to severe mental health disorders.", sw: "Kutokana na changamoto kubwa za kiakili." } },
        { title: { en: "Non-payment", sw: "Ada", }, desc: { en: "Failure to pay subscription fees for 2 consecutive years.", sw: "Kushindwa kulipa ada za uanachama kwa muda wa miaka 2." } },
        { title: { en: "Demise", sw: "Kifo" }, desc: { en: "Natural termination upon the member's passing.", sw: "Kukoma kwa uanachama kutokana na kufariki dunia." } }
      ]
    }
  },

  contactPage: {
    hero: {
      kicker: { en: "GET IN TOUCH", sw: "WASILIANA NASI" },
      title: { 
        en: "We Are Ready to Hear From You & Support the Community", 
        sw: "Tuko Tayari Kusikia Kutoka Kwako & Kusaidia Jamii" 
      }
    },
    info: {
      title: { en: "Our Head Office", sw: "Makao Makuu Yetu" },
      addressTitle: { en: "Physical Address", sw: "Anwani ya Eneo" },
      addressDesc: { 
        en: "Mamuna Street, nearby The University of Arusha, IMBASENI Ward, Arumeru District, Arusha Region.", 
        sw: "Mamuna Street, karibu na Chuo Kikuu cha Arusha, Kata ya IMBASENI, Wilaya ya Arumeru, Mkoa wa Arusha." 
      },
      postalTitle: { en: "Postal Address", sw: "Anwani ya Posta" },
      postalDesc: { en: "P. O. BOX 8211, Arusha, Tanzania.", sw: "S. L. P 8211, Arusha, Tanzania." },
      operationTitle: { en: "Area of Operation", sw: "Eneo la Utendaji Kazi" },
      operationDesc: { 
        en: "KUKAJA operates on a National scale, reaching out to all regions across the United Republic of Tanzania.", 
        sw: "KUKAJA inafanya kazi katika ngazi ya Taifa, ikifikia mikoa yote kote Jamhuri ya Muungano wa Tanzania." 
      }
    },
    channels: {
      title: { en: "Direct Contacts", sw: "Mawasiliano ya Moja kwa Moja" },
      phoneTitle: { en: "Call Official Bearers", sw: "Wapigie Viongozi Wakuu" },
      phoneDesc: { en: "+255 754 XXX XXX / +255 655 XXX XXX", sw: "+255 754 XXX XXX / +255 655 XXX XXX" },
      emailTitle: { en: "Official Email Address", sw: "Barua Pepe Rasmi" },
      emailDesc: { en: "info@kukaja.or.tz / kukaja.tz@gmail.com", sw: "info@kukaja.or.tz / kukaja.tz@gmail.com" },
      hoursTitle: { en: "Office Hours", sw: "Muda wa Kazi" },
      hoursDesc: { en: "Monday - Friday: 8:00 AM - 4:00 PM", sw: "Jumatatu - Ijumaa: Saa 2:00 Asubuhi - Saa 10:00 Jioni" }
    }
  }
};
